'use client';

import styled from 'styled-components';

import { Image, Skeleton } from '@zoomit/primitives';

import { theme } from '../../theme';

export type Props = {
  src: any;
} & Partial<AvatarBaseType> &
  React.HTMLAttributes<HTMLDivElement>;

type AvatarSize = keyof typeof avatarSize;

type AvatarBaseType = {
  size: AvatarSize;
};

const avatarSize = {
  small: 2.4,
  medium: 3.2,
  medLarge: 4,
  large: 4.8,
  xlarge: 6.4,
  xxlarge: 10.4,
};

export const Avatar = (props: Props) => {
  const { src, size = 'medium', ...rest } = props;

  const computedSize = avatarSize[size];

  return (
    <AvatarBase size={size} {...rest}>
      {src ? (
        <Image
          src={src}
          width={computedSize * 10}
          height={computedSize * 10}
          alt=""
          className="object-cover"
          sizes={`32px`}
        />
      ) : (
        <Skeleton width={computedSize} height={computedSize} variant="circular" />
      )}
    </AvatarBase>
  );
};

const AvatarBase = styled.div<AvatarBaseType>`
  width: ${({ size }) => avatarSize[size]}rem;
  height: ${({ size }) => avatarSize[size]}rem;
  border-radius: var(${theme.radius.full});
  overflow: hidden;
  background: var(${theme.background2});
  flex-shrink: 0;
`;
